
/* injects from baggage-loader */

'use strict';

/**
 * Controller used by summary module to modify the values of the HTML DOM elements
 * in the scope of the summary component Dialog
 *
 * @param {any} $mdDialog
 * @param {any} title
 * @param {any} processType
 * @param {any} user
 * @param {any} components
 * @param {any} isErrorDialog
 * @param {any} summaryConstant
 * @param {any} utilitiesConstant
 * @param {any} utilitiesFactory
 */
function summaryDialogController($mdDialog, title, processType, user, components, isErrorDialog, summaryConstant, utilitiesConstant, utilitiesFactory) {
	'ngInject';

	let vm = this;

	vm.utilitiesConstant = utilitiesConstant;
	vm.summaryConstant = summaryConstant;
	vm.title = title;
	vm.processType = processType,
	vm.user = user;
	vm.components = components;
	vm.isErrorDialog = isErrorDialog;

	/**
	 * Hide dialog.
	 * @return
	 */
	vm.cancel = () => {
		$mdDialog.cancel();
	};

	/**
	 * Sends the decision took by the user to the summary controller, true if confirm, false if exit.
	 * @return
	 */
	vm.confirm = () => {
		$mdDialog.hide();
	}

	/**
	 * Gets the second half of the array
 	 * @return
 	 */
	vm.orderList = componentArray => utilitiesFactory.orderComponents(componentArray);
}

export default summaryDialogController;



// WEBPACK FOOTER //
// ./src/app/auth/components/summary/summaryDialog.controller.js